

export const PATH = {
    ROOT: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    PROFILE_HOME: "/profile",
    PROFILE_UPDATE: "/profile/personal-data",
    PROFILE_CHANGE_PASSWORD: "/profile/change-password",
    PROFILE_UPDATE_PHONE: "/profile/update-phone",
    PROFILE_UPDATE_PHONE_PIN_CONFIRMATION: "/profile/update-phone/pin-confirmation",
    PROFILE_DELETE: "/profile/delete",
    MAIN: "/main",
    TAKEAWAY: "/takeaway",
    TAKEAWAY_ORDER_REVIEW: "/takeaway/order-review",
    TAKEAWAY_THANK_YOU: "/takeaway/thank-you",
    BAR_THANK_YOU: "/bar/thank-you",
    SCHEDULES: "/schedules",
    ALL_RESERVATIONS: "/all-reservations",
    CREATE_RESERVATION: "/create-reservation",
    RESERVATION_DETAILS: "/reservation-details",
    ALL_PRODUCTS: "/menu",
    LOGIN_OR_CONTINUE_AS_GUEST: "/login-or-continue-as-guest",
    PRODUCT_DETAILS: "/product-details",
    ORDER_REVIEW:  "/order-review",
    GROUP_ORDER_REVIEW:  "/group-order-review",
    ORDER_SUMMARY: "/order-summary",
    GROUP_ORDER_SUMMARY: "/group-order-summary",
    GROUP_PAYMENT: "/group-payment",
    ORDER_HISTORY: "/order-history",
    PAYMENT: "/payment",

    THANK_YOU:"/thank-you",
    SCAN_QR_TO_CONTINUE: "/scan-qr-to-continue",



    TABLE_QR_SCAN: "/links/tables",
    LINK_SCAN: "/links",
    BAR_PICKUP_SCAN: "/links/bar-pickup",
    PAGE_SCAN: "/links"
}

